var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color"},[_c('div',{staticClass:"colorBox"},[_c('el-color-picker',{attrs:{"size":"small"},model:{value:(_vm.colorObj.color[0].item),callback:function ($$v) {_vm.$set(_vm.colorObj.color[0], "item", $$v)},expression:"colorObj.color[0].item"}}),_c('span',{on:{"click":_vm.updateColor}},[_vm._v("重置")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }